import React from 'react';
import { motion } from 'framer-motion';
import { Star, Play } from 'lucide-react';
import { Button } from './ui/Button';
import { Card } from './ui/Card';
export function GamesShowcase() {
  const games = [{
    name: 'Lumino Quest',
    genre: 'Adventure',
    rating: 4.9,
    age: '6+',
    color: 'from-blue-400 to-indigo-500'
  }, {
    name: 'Frosty Bounce',
    genre: 'Arcade',
    rating: 4.8,
    age: '4+',
    color: 'from-cyan-300 to-blue-400'
  }, {
    name: 'Coral Dash',
    genre: 'Racing',
    rating: 4.7,
    age: '5+',
    color: 'from-orange-300 to-red-400'
  }, {
    name: 'Starwhirl',
    genre: 'Puzzle',
    rating: 5.0,
    age: '7+',
    color: 'from-purple-400 to-pink-500'
  }, {
    name: 'Pebble Kingdom',
    genre: 'Strategy',
    rating: 4.6,
    age: '8+',
    color: 'from-green-400 to-emerald-600'
  }, {
    name: 'Zephyr Run',
    genre: 'Action',
    rating: 4.8,
    age: '6+',
    color: 'from-yellow-300 to-orange-400'
  }];
  return <section id="games" className="py-24 bg-white" data-id="element-67">
      <div className="container mx-auto px-4 md:px-6" data-id="element-68">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-6" data-id="element-69">
          <div data-id="element-70">
            <h2 className="text-4xl md:text-5xl font-bold text-candy-dark mb-4" data-id="element-71">
              Trending in the Vault
            </h2>
            <p className="text-xl text-gray-500" data-id="element-72">
              The most played games this week by our community.
            </p>
          </div>
          <Button variant="secondary" data-id="element-73">View All Games</Button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-74">
          {games.map((game, index) => <Card key={index} className="group cursor-pointer border-none shadow-lg hover:shadow-2xl transition-all duration-300" data-id="element-75">
              {/* Game Image Placeholder */}
              <div className={`h-48 w-full bg-gradient-to-br ${game.color} relative overflow-hidden`} data-id="element-76">
                <div className="absolute inset-0 bg-black/10 group-hover:bg-black/0 transition-colors" data-id="element-77" />

                {/* Play Button Overlay */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-78">
                  <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-lg transform scale-50 group-hover:scale-100 transition-transform duration-300" data-id="element-79">
                    <Play className="w-8 h-8 text-candy-pink fill-candy-pink ml-1" data-id="element-80" />
                  </div>
                </div>

                <div className="absolute top-4 right-4 bg-white/90 backdrop-blur px-3 py-1 rounded-full text-xs font-bold text-gray-700 shadow-sm" data-id="element-81">
                  {game.age}
                </div>
              </div>

              <div className="p-6 bg-white" data-id="element-82">
                <div className="flex justify-between items-start mb-2" data-id="element-83">
                  <span className="text-xs font-bold uppercase tracking-wider text-candy-purple bg-candy-purple/10 px-2 py-1 rounded-md" data-id="element-84">
                    {game.genre}
                  </span>
                  <div className="flex items-center gap-1 text-amber-400 font-bold text-sm" data-id="element-85">
                    <Star className="w-4 h-4 fill-amber-400" data-id="element-86" />
                    {game.rating}
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-gray-800 group-hover:text-candy-pink transition-colors" data-id="element-87">
                  {game.name}
                </h3>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}